import { apiSlice } from '@/features/api/apiSlice';

export type Member = {
  userId: string;
  role: 'owner' | 'admin' | 'editor' | 'viewer';
  joinedAt: string | null;
  invitedBy: string | null;
  user: { id: string; email: string; name: string | null; avatarUrl: string | null; lastLoginAt: string | null };
};

export type Invitation = {
  id: string;
  email: string;
  role: 'admin' | 'editor' | 'viewer';
  expiresAt: string;
  createdAt: string;
};

export const membersApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listMembers: b.query<Member[], void>({
      query: () => '/members',
      providesTags: ['Member'],
    }),
    listInvitations: b.query<Invitation[], void>({
      query: () => '/invitations',
      providesTags: ['Invitation'],
    }),
    inviteMember: b.mutation<{ id: string; expiresAt: string }, { email: string; role: 'admin' | 'editor' | 'viewer' }>({
      query: (body) => ({ url: '/invitations', method: 'POST', body }),
      invalidatesTags: ['Invitation'],
    }),
    revokeInvitation: b.mutation<void, string>({
      query: (id) => ({ url: `/invitations/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Invitation'],
    }),
    acceptInvitation: b.mutation<{ organizationId: string }, string>({
      query: (token) => ({ url: '/invitations/accept', method: 'POST', body: { token } }),
      invalidatesTags: ['Me', 'Member'],
    }),
    updateMemberRole: b.mutation<unknown, { userId: string; role: Member['role'] }>({
      query: ({ userId, role }) => ({ url: `/members/${userId}/role`, method: 'PATCH', body: { role } }),
      invalidatesTags: ['Member'],
    }),
    removeMember: b.mutation<void, string>({
      query: (userId) => ({ url: `/members/${userId}`, method: 'DELETE' }),
      invalidatesTags: ['Member'],
    }),
  }),
});

export const {
  useListMembersQuery,
  useListInvitationsQuery,
  useInviteMemberMutation,
  useRevokeInvitationMutation,
  useAcceptInvitationMutation,
  useUpdateMemberRoleMutation,
  useRemoveMemberMutation,
} = membersApi;
